import React from 'react'
import themes from '../../../theme'
import { useGlobalStore } from '../../../store'

const Delete = () => {
  const { theme } = useGlobalStore()
  const borderColor = themes[theme].components.MuiIconButton.styleOverrides.color
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.1667 5.0013H18.3334V6.66797H16.6667V17.5013C16.6667 17.7223 16.5789 17.9343 16.4227 18.0906C16.2664 18.2468 16.0544 18.3346 15.8334 18.3346H4.16675C3.94573 18.3346 3.73377 18.2468 3.57749 18.0906C3.42121 17.9343 3.33341 17.7223 3.33341 17.5013V6.66797H1.66675V5.0013H5.83341V2.5013C5.83341 2.28029 5.92121 2.06833 6.07749 1.91205C6.23377 1.75577 6.44573 1.66797 6.66675 1.66797H13.3334C13.5544 1.66797 13.7664 1.75577 13.9227 1.91205C14.0789 2.06833 14.1667 2.28029 14.1667 2.5013V5.0013ZM15.0001 6.66797H5.00008V16.668H15.0001V6.66797ZM7.50008 9.16797H9.16675V14.168H7.50008V9.16797ZM10.8334 9.16797H12.5001V14.168H10.8334V9.16797ZM7.50008 3.33464V5.0013H12.5001V3.33464H7.50008Z" fill={borderColor}/>
    </svg>
  )
}

export default Delete
